export type Language = "pl" | "en";

const translations: Record<Language, Record<string, string>> = {
  pl: {
    // Navigation
    back: "Wstecz",
    next: "Dalej",
    seeResults: "Zobacz wyniki",
    skip: "Pomiń",
    continue: "Kontynuuj",
    
    // Progress
    questionOf: "Pytanie {current} z {total}",
    
    // Loader messages
    analyzingWebsite: "Analizuję stronę internetową...",
    searchingCompetitors: "Szukam konkurencji...",
    verifyingData: "Weryfikuję dane...",
    complete: "Gotowe!",
    
    // B2C Exit
    b2cExitTitle: "LinkedIn = B2B",
    b2cExitSubtitle: "LinkedIn Social Selling sprawdza się głównie w sprzedaży B2B",
    b2cExitDesc: "Niestety, dla modelu B2C/E-commerce LinkedIn nie jest optymalnym kanałem sprzedaży. Rozważ inne kanały marketingowe jak Facebook, Instagram czy Google Ads.",
    b2cExitButton: "Rozumiem, wróć do strony głównej",
    
    // Toasts
    analysisTimeout: "Analiza konkurencji trwa zbyt długo",
    analysisTimeoutDesc: "Pomijamy to pytanie i przechodzimy dalej do wyniku.",
    linkedinNotFound: "Nie udało się znaleźć profilu LinkedIn",
    linkedinNotFoundDesc: "Pomijamy to pytanie i przechodzimy dalej.",
    skipCompetitors: "Pomijamy pytanie o konkurencję",
    skipCompetitorsDesc: "Nie znaleźliśmy wystarczającej liczby konkurentów dla Twojej domeny.",
    
    // Questions
    q1: "Czy posiadasz profil na LinkedIn?",
    q1_yes: "Tak",
    q1_inactive: "Tak jestem, ale nie jestem aktywny",
    q1_no: "Nie",
    q1_someone: "Ktoś z firmy jest na LinkedIn",
    
    q2: "W jakim sektorze działasz?",
    q2_b2b: "B2B (Business to Business)",
    q2_b2g: "B2G (Business to Government)",
    q2_tender: "Przetargi (Tender Sales)",
    q2_d2c: "D2C (Direct to Consumer)",
    q2_b2c: "B2C (Business to Consumer)",
    q2_ecommerce: "E-commerce",
    
    q3: "Ilu ludzi realnie zajmuje się sprzedażą w Twojej firmie?",
    q3_5plus: "5 lub więcej",
    q3_2to4: "2–4",
    q3_1person: "1 osoba",
    q3_only_me: "Tylko ja",
    
    q4: "Jaka jest strona internetowa Twojej firmy?",
    q4_placeholder: "np. microsoft.com lub www.microsoft.com",
    
    q5: "Czy śledzicie źródło pochodzenia leadów (np. reklama, polecenia, blog, targi, wydarzenia)?",
    q5_detailed: "Tak, szczegółowo analizujemy",
    q5_general: "Tak, ale ogólnie",
    q5_none: "Nie śledzimy",
    
    q6: "Czy posiadacie Sales Navigator lub Premium na LinkedIn?",
    q6_sales_nav: "Tak, Sales Navigator",
    q6_premium: "Tak, Premium",
    q6_free: "Nie, tylko konto darmowe",
    q6_none: "Nie mamy LinkedIn",
    q6_dont_know: "Nie wiem",
    
    q7: "Czy używacie CRMa/sprzedażowych narzędzi?",
    q7_crm_active: "Mamy wdrożony CRM i aktywnie go używamy",
    q7_crm_partial: "Mamy CRM, ale nie jest w pełni wykorzystywany",
    q7_spreadsheets: "Używamy prostych narzędzi (Excel, Google Sheets)",
    q7_no_tools: "Nie używamy żadnych narzędzi",
    q7_other: "Inne",
    
    q8: "Jaka jest roczna wartość typowego kontraktu (ACV - annual contract value)?",
    q8_over_50k: "> 50 000 PLN",
    q8_10to50k: "10–50 000 PLN",
    q8_under_10k: "< 10 000 PLN",
    q8_dont_know: "Nie wiem",
    q8_wont_say: "Nie powiem",
    
    q9: "Ile trwa średnio cykl sprzedaży?",
    q9_3months: "Do 3 miesięcy",
    q9_6months: "Do 6 miesięcy",
    q9_1year: "Do 1 roku",
    q9_over_1year: "Powyżej roku",
    
    q10: "Czy macie zdefiniowane ICP (idealnego klienta) i listę np. 500+ kont?",
    q10_yes: "Tak",
    q10_in_progress: "W trakcie",
    q10_no: "Nie",
    q10_dont_know: "Nie wiem",
    q10_why_need: "A po co mi to..",
    
    q11: "Które kanały sprzedaży obecnie generują najwięcej sprzedaży?",
    q11_cold_email: "Cold outreach / e-mail",
    q11_referrals: "Polecenia",
    q11_inbound: "Inbound z reklam lub strony",
    q11_events: "Targi/eventy",
    q11_phone: "Telefon",
    q11_partners: "Partnerzy, dystrybutorzy",
    q11_other: "Inne",
    q11_dont_know: "Nie wiem",
    
    q12: "Ile teraz wydajesz na marketing i sprzedaż miesięcznie?",
    q12_above_50k: "Powyżej 50 tys.",
    q12_30to49k: "Od 30 do 49 tys.",
    q12_10to29k: "Od 10 do 29 tys.",
    q12_5to9k: "Pomiędzy 5 a 9 tys.",
    q12_2to4k: "Pomiędzy 2-4 tys.",
    q12_below_2k: "Mniej niż 2 tys.",
    
    q13: "Czy używacie automatyzacji/AI w firmie?",
    q13_yes: "Tak",
    q13_no: "Nie",
    q13_dont_know: "Nie wiem",
    
    q14: "Czy znasz takie pojęcia i je rozumiesz? (zaznacz wszystkie, które znasz i rozumiesz)",
    q14_prospecting: "Prospecting (aktywne generowanie kontaktów do sprzedaży)",
    q14_inbound: "Inbound (przychodzący marketing)",
    q14_outbound: "Outbound (wychodzący marketing)",
    q14_lead_gen: "Lead Generation (generowanie leadów)",
    q14_ppc: "PPC (Pay Per Click)",
    q14_demand_gen: "Demand Generation (budowanie popytu)",
    q14_icp: "ICP (Ideal Client Profile – profil idealnego klienta)",
    q14_abm: "ABM/S (Account-Based Marketing/Sales – marketing/sprzedaż oparta na kontach)",
    q14_cold_outreach: "Cold Outreach (zimny kontakt)",
    q14_funnel: "Sales Funnel / Pipeline (lejek sprzedażowy)",
    q14_discovery: "Discovery Call (rozmowa odkrywcza)",
    q14_personal_brand: "Marka osobista / Social Selling",
    q14_bant: "BANT (Budget Authority, Need, Timing)",
    q14_branding: "Branding",
    
    q15: "Jak oceniasz potencjał LinkedIna dla Twojej firmy?",
    q15_high: "Duży, rynek tam już jest",
    q15_interesting: "Ciekawy, ale potrzebuję danych",
    q15_competitive: "Konkurencja mocno tam działa",
    q15_skeptical: "Nie wiem / sceptycznie",
    
    q16: "Które z tych firm konkurencyjnych znasz?",
    q17: "Czy to jest profil LinkedIn Waszej firmy?",
    q17_yes: "Tak, to nasz profil",
    q17_no: "Nie, to nie nasz profil",
    q17_no_profile: "Nie posiadamy profilu firmowego na LinkedIn",
  },
  en: {
    // Navigation
    back: "Back",
    next: "Next",
    seeResults: "See results",
    skip: "Skip",
    continue: "Continue",
    
    // Progress
    questionOf: "Question {current} of {total}",
    
    // Loader messages
    analyzingWebsite: "Analyzing website...",
    searchingCompetitors: "Searching for competitors...",
    verifyingData: "Verifying data...",
    complete: "Complete!",
    
    // B2C Exit
    b2cExitTitle: "LinkedIn = B2B",
    b2cExitSubtitle: "LinkedIn Social Selling works mainly for B2B sales",
    b2cExitDesc: "Unfortunately, for B2C/E-commerce models, LinkedIn is not an optimal sales channel. Consider other marketing channels like Facebook, Instagram, or Google Ads.",
    b2cExitButton: "I understand, return to homepage",
    
    // Toasts
    analysisTimeout: "Competitor analysis is taking too long",
    analysisTimeoutDesc: "Skipping this question and moving to results.",
    linkedinNotFound: "Could not find LinkedIn profile",
    linkedinNotFoundDesc: "Skipping this question and moving forward.",
    skipCompetitors: "Skipping competitor question",
    skipCompetitorsDesc: "We couldn't find enough competitors for your domain.",
    
    // Questions
    q1: "Do you have a LinkedIn profile?",
    q1_yes: "Yes",
    q1_inactive: "Yes, but I'm not active",
    q1_no: "No",
    q1_someone: "Someone from the company is on LinkedIn",
    
    q2: "What sector do you operate in?",
    q2_b2b: "B2B (Business to Business)",
    q2_b2g: "B2G (Business to Government)",
    q2_tender: "Tender Sales",
    q2_d2c: "D2C (Direct to Consumer)",
    q2_b2c: "B2C (Business to Consumer)",
    q2_ecommerce: "E-commerce",
    
    q3: "How many people are involved in sales at your company?",
    q3_5plus: "5 or more",
    q3_2to4: "2–4",
    q3_1person: "1 person",
    q3_only_me: "Just me",
    
    q4: "What is your company's website?",
    q4_placeholder: "e.g. microsoft.com or www.microsoft.com",
    
    q5: "Do you track lead sources (e.g. ads, referrals, blog, trade shows)?",
    q5_detailed: "Yes, we analyze in detail",
    q5_general: "Yes, but generally",
    q5_none: "We don't track",
    
    q6: "Do you have Sales Navigator or Premium on LinkedIn?",
    q6_sales_nav: "Yes, Sales Navigator",
    q6_premium: "Yes, Premium",
    q6_free: "No, only free account",
    q6_none: "We don't have LinkedIn",
    q6_dont_know: "I don't know",
    
    q7: "Do you use CRM/sales tools?",
    q7_crm_active: "We have CRM and actively use it",
    q7_crm_partial: "We have CRM, but it's not fully utilized",
    q7_spreadsheets: "We use simple tools (Excel, Google Sheets)",
    q7_no_tools: "We don't use any tools",
    q7_other: "Other",
    
    q8: "What is the typical annual contract value (ACV)?",
    q8_over_50k: "> €12,000 / $13,000",
    q8_10to50k: "€2,500 – €12,000",
    q8_under_10k: "< €2,500 / $2,700",
    q8_dont_know: "I don't know",
    q8_wont_say: "I won't say",
    
    q9: "How long is the average sales cycle?",
    q9_3months: "Up to 3 months",
    q9_6months: "Up to 6 months",
    q9_1year: "Up to 1 year",
    q9_over_1year: "Over a year",
    
    q10: "Do you have a defined ICP (ideal customer) and a list of 500+ accounts?",
    q10_yes: "Yes",
    q10_in_progress: "In progress",
    q10_no: "No",
    q10_dont_know: "I don't know",
    q10_why_need: "Why would I need this..",
    
    q11: "Which sales channels currently generate the most sales?",
    q11_cold_email: "Cold outreach / email",
    q11_referrals: "Referrals",
    q11_inbound: "Inbound from ads or website",
    q11_events: "Trade shows/events",
    q11_phone: "Phone",
    q11_partners: "Partners, distributors",
    q11_other: "Other",
    q11_dont_know: "I don't know",
    
    q12: "How much do you spend on marketing and sales monthly?",
    q12_above_50k: "Above €12,000",
    q12_30to49k: "€7,000 – €12,000",
    q12_10to29k: "€2,500 – €7,000",
    q12_5to9k: "€1,200 – €2,200",
    q12_2to4k: "€500 – €1,000",
    q12_below_2k: "Less than €500",
    
    q13: "Do you use automation/AI in your company?",
    q13_yes: "Yes",
    q13_no: "No",
    q13_dont_know: "I don't know",
    
    q14: "Do you know and understand these concepts? (select all you know)",
    q14_prospecting: "Prospecting (active lead generation)",
    q14_inbound: "Inbound (inbound marketing)",
    q14_outbound: "Outbound (outbound marketing)",
    q14_lead_gen: "Lead Generation",
    q14_ppc: "PPC (Pay Per Click)",
    q14_demand_gen: "Demand Generation",
    q14_icp: "ICP (Ideal Client Profile)",
    q14_abm: "ABM/S (Account-Based Marketing/Sales)",
    q14_cold_outreach: "Cold Outreach",
    q14_funnel: "Sales Funnel / Pipeline",
    q14_discovery: "Discovery Call",
    q14_personal_brand: "Personal Brand / Social Selling",
    q14_bant: "BANT (Budget Authority, Need, Timing)",
    q14_branding: "Branding",
    
    q15: "How do you rate LinkedIn's potential for your company?",
    q15_high: "High, the market is already there",
    q15_interesting: "Interesting, but I need data",
    q15_competitive: "Competition is strong there",
    q15_skeptical: "I don't know / skeptical",
    
    q16: "Which of these competitor companies do you know?",
    q17: "Is this your company's LinkedIn profile?",
    q17_yes: "Yes, this is our profile",
    q17_no: "No, this is not our profile",
    q17_no_profile: "We don't have a company LinkedIn profile",
  }
};

export function getQuizTranslation(lang: Language) {
  const dict = translations[lang] || translations.en;
  return (key: string, params?: Record<string, string | number>): string => {
    let text = dict[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  };
}

// Question to translation key mapping
export const questionKeyMap: Record<number, string> = {
  1: "q1",
  2: "q2",
  3: "q3",
  4: "q4",
  5: "q5",
  6: "q6",
  7: "q7",
  8: "q8",
  9: "q9",
  10: "q10",
  11: "q11",
  12: "q12",
  13: "q13",
  14: "q14",
  15: "q15",
  16: "q16",
  17: "q17",
};

// Option value to translation key mapping
export const optionKeyMap: Record<string, string> = {
  // Q1
  "yes": "q1_yes",
  "inactive": "q1_inactive",
  "no": "q1_no",
  "someone": "q1_someone",
  // Q2
  "b2b": "q2_b2b",
  "b2g": "q2_b2g",
  "tender": "q2_tender",
  "d2c": "q2_d2c",
  "b2c": "q2_b2c",
  "ecommerce": "q2_ecommerce",
  // Q3
  "5plus": "q3_5plus",
  "2to4": "q3_2to4",
  "1person": "q3_1person",
  "only_me": "q3_only_me",
  // Q5
  "detailed": "q5_detailed",
  "general": "q5_general",
  "none": "q5_none",
  // Q6
  "sales_nav": "q6_sales_nav",
  "premium": "q6_premium",
  "free": "q6_free",
  "dont_know": "q6_dont_know",
  // Q7
  "crm_active": "q7_crm_active",
  "crm_partial": "q7_crm_partial",
  "spreadsheets": "q7_spreadsheets",
  "no_tools": "q7_no_tools",
  "other": "q7_other",
  // Q8
  "over_50k": "q8_over_50k",
  "10to50k": "q8_10to50k",
  "under_10k": "q8_under_10k",
  "wont_say": "q8_wont_say",
  // Q9
  "3months": "q9_3months",
  "6months": "q9_6months",
  "1year": "q9_1year",
  "over_1year": "q9_over_1year",
  // Q10
  "in_progress": "q10_in_progress",
  "why_need": "q10_why_need",
  // Q11
  "cold_email": "q11_cold_email",
  "referrals": "q11_referrals",
  "inbound": "q11_inbound",
  "events": "q11_events",
  "phone": "q11_phone",
  "partners": "q11_partners",
  // Q12
  "above_50k": "q12_above_50k",
  "30to49k": "q12_30to49k",
  "10to29k": "q12_10to29k",
  "5to9k": "q12_5to9k",
  "2to4k": "q12_2to4k",
  "below_2k": "q12_below_2k",
  // Q13 uses yes/no
  // Q14
  "prospecting": "q14_prospecting",
  "outbound": "q14_outbound",
  "lead_gen": "q14_lead_gen",
  "ppc": "q14_ppc",
  "demand_gen": "q14_demand_gen",
  "icp": "q14_icp",
  "abm": "q14_abm",
  "cold_outreach": "q14_cold_outreach",
  "funnel": "q14_funnel",
  "discovery": "q14_discovery",
  "personal_brand": "q14_personal_brand",
  "bant": "q14_bant",
  "branding": "q14_branding",
  // Q15
  "high": "q15_high",
  "interesting": "q15_interesting",
  "competitive": "q15_competitive",
  "skeptical": "q15_skeptical",
  // Q17
  "no_profile": "q17_no_profile",
};
